import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import PageLayout from '@/components/layout/PageLayout';
import ManualCreditForm from '@/components/credits/ManualCreditForm';

const CreateCreditNotePage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout maxWidth="lg" padding="md">
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/finances/credit-notes">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back to Customer Credits
            </Link>
          </Button>
        </div>

        <div>
          <h1 className="text-2xl font-bold font-montserrat">Create Manual Credit</h1>
          <p className="text-sm text-muted-foreground">
            Issue a manual credit to a customer. A credit note number will be generated automatically.
          </p>
        </div>

        <ManualCreditForm
          onSave={() => navigate('/finances/credit-notes')}
          onCancel={() => navigate('/finances/credit-notes')}
        />
      </div>
    </PageLayout>
  );
};

export default CreateCreditNotePage;
